import React from "react";
import styled from "styled-components";
import tw from "twin.macro";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-8`;
const Grid = tw.div`
  grid
  grid-cols-1
  gap-6
`;

const Card = styled.a`
  ${tw`
    flex flex-col h-full w-full relative focus:outline-none cursor-pointer transition duration-300 transform bg-primary-200
    rounded-tl-4xl rounded-br-4xl
    p-6
  `}
  &:hover {
    ${tw`bg-primary-300 scale-105`}
  }
`;

const Title = tw.h5`text-sm text-left font-semibold text-gray-900`;

const Heading = tw.span`
  inline-block my-4 pl-3 py-1 text-xl font-bold border-l-4 border-primary-500
`;

export default function OtherNewsNoImage({ cards, heading, onItemClick }) {
  if (!cards || cards.length === 0) return null;

  return (
    <Container>
      <Content>
        {heading && <Heading>{heading}</Heading>}
        <Grid>
          {cards.map((card, index) => (
            <Card
              key={index}
              href={card.buttonLink}
              onClick={() => onItemClick?.(card)}
            >
              <Title>{card.title}</Title>
            </Card>
          ))}
        </Grid>
      </Content>
    </Container>
  );
}
